let translations = {
  active: 'Active',
  allUsers: 'All users',
  allWorkflows: 'All workflows',
  and: 'And',
  back: 'Back',
  by: 'By',
  cancel: 'Cancel',
  clone: 'Clone',
  create: 'Create',
  done: 'Done',
  download: 'Download',
  exportList: 'Export list',
  file: 'File',
  inactive: 'Inactive',
  list: 'List',
  map: 'Map',
  goto: 'Go to',
  next: 'Next',
  or: 'Or',
  previous: 'Previous',
  satellite: 'Satellite',
  submit: 'Submit',
  title: 'AirFinder',
  unknown: 'unknown',
  resendInvite: 'Resend Invite',
  viewInvite: 'View Invite',
  add: {
    add: 'Add',
    addArea: 'Area',
    addCategory: 'Add Category',
    addGroup: 'Add Group',
    addLocation: 'Location',
    addSite: 'Site',
    addTag: 'Add Tag(s)',
    addZone: 'Zone',
    addUser: 'Add User',
    back: 'Back',
    save: 'Save',
    set: 'set',
    title: 'add',
    site: {
      title: 'Add Site'
    },
    user: {
      sitePermissions: {
        label: 'Site Permissions',
        placeholder: 'Select sites'
      },
      userPermissions: {
        label: 'Permission(s)',
        placeholder: 'Select permissions'
      },
      email: {
        label: 'Email',
        placeholder: "Enter user email"
      },
      name: {
        label: 'Name',
        placeholder: 'Enter name'
      },
      site: {
        label: 'Site'
      }
    },
    area: {
      site: 'Select a Site',
      title: 'Add Area'
    },
    bulkUpload: {
      errorCount: 'Errors',
      errorLine: 'Line',
      errorText: 'Error',
      format: 'Make sure you use following format while uploading.',
      note:
        ' NOTE: groups, field_1 and field_2 are optional. You can use the label for category and groups or just the id if known.',
      recordCount: 'Records',
      resultsTitle: 'Bulk Upload Results',
      sample: 'Sample.csv',
      successCount: 'Succeeded',
      title: 'Bulk Upload'
    },
    tag: {
      title: 'Add Tag(s)'
    },
    group: {
      title: 'Add Group'
    },
    category: {
      title: 'Add Category'
    },
    zone: {
      drawing: 'Add a zone by drawing on the map',
      title: 'Add Zone',
      site: {
        label: 'Site',
        placeholder: 'Select a Site'
      },
      area: {
        label: 'Area',
        placeholder: 'Select an Area'
      },
      zone: {
        label: 'Zone Name',
        placeholder: "Enter Zone's name"
      }
    },
    location: {
      drawing: 'Add a location by dropping a marker',
      title: 'Add Location',
      name: {
        label: 'Location Name',
        placeholder: 'Enter Location Name'
      },
      id: {
        label: 'Location ID',
        placeholder: "Enter Location's ID"
      },
      site: {
        label: 'Site',
        placeholder: 'Select a Site'
      },
      area: {
        label: 'Area',
        placeholder: 'Select an Area'
      },
      location: {
        label: 'Location'
      },
      zone: {
        label: 'Zone',
        placeholder: 'Select a Zone'
      }
    },
    history: {
      startDate: 'Start Date',
      endDate: 'End Date'
    },
    triggers: {
      add: 'Add Trigger',
      noDataFirst: `Looks like you haven't set up a trigger yet.`,
      noDataSecond: `Let's set that up now.`,
      tagProperty: 'Select Tag Property',
      testCriteria: 'Test Criteria',
      trigger: 'Trigger'
    },
    action: {
      add: 'Add Action'
    },
    criteria: {
      add: 'Add Criteria',
      equals: 'equals',
      in: 'in',
      is: 'is',
      isNot: 'is not',
      isGreaterThan: 'is greater than',
      isLessThan: 'is less than',
      known: 'is known',
      lost: 'lost',
      notEqual: 'does not equal',
      notIn: 'not in',
      notLost: 'not lost',
      select: 'Please select a %{property}',
      unknown: 'is unknown'
    },
    workflows: {
      add: 'Add Workflow',
      noDataFirst: `Looks like you haven't set up a workflow yet.`,
      noDataSecond: `Let's set that up now.`,
      noDataTable: 'No workflows found.',
      title: 'Workflows'
    }
  },
  delete: {
    confirmDelete: 'Are you sure you want to delete:',
    delete: 'Delete',
    deleteArea: 'Delete Area',
    deleteAction: 'Delete Action',
    confirmDeleteUser: 'Delete site permissions for %{customValue}',
    deleteLabel: 'Delete Site Permissions',
    deleteCategory: {
      title: 'Delete Category',
      confirm: 'Are you sure you want to delete',
      label: 'Select a Category'
    },
    deleteGroup: 'Delete Group',
    deleteIt: 'Yes, Delete',
    deleteLocation: 'Delete Location',
    deleteSite: 'Delete Site',
    deleteTag: 'Delete Tag',
    deleteTrigger: 'Delete Trigger',
    deleteWorkflow: 'Delete Workflow',
    deleteZone: 'Delete Zone',
    keepIt: 'No, Keep',
    confirmDeleteAccessPoint: 'Delete Access Point %{customValue}',
    deleteAccessPointLabel: 'Delete Access Point',
    confirmDeleteGateway: 'Delete Gateway  %{customValue}',
    deleteGatewayLabel: 'Delete Gateway'
  },
  edit: {
    edit: 'Edit',
    save: 'Save',
    noItemsFound: 'No items found',
    site: {
      title: 'Edit Site'
    },
    tag: {
      title: 'Edit'
    },
    category: {
      category: 'Category',
      title: 'Edit Category',
      noCategoriesFound: 'No categories found',
      categories: 'Categories'
    },
    group: {
      group: 'Group',
      title: 'Edit Group',
      noGroupsFound: 'No groups found',
      groups: 'Groups'
    },
    area: {
      title: 'Edit Area'
    },
    zone: {
      title: 'Edit Zone'
    },
    labels: {
      labels: 'Labels',
      siteLabels: 'Site Labels',
      info: 'Add/update your labels for the following column names',
      note: 'NOTE: These are only applied to the list views'
    }
  },
  admin: {
    admin: 'Admin',
    alerts: 'Account Alerts',
    searchPlaceholder: 'Find a site or gateway',
    status: 'Status',
    users: 'Users',
    network: 'Network status overview'
  },
  assets: {
    area: 'Area',
    location: 'Location',
    site: 'Site',
    zone: 'Zone',
    zonesLocations: 'Zones & Locations'
  },
  data: {
    area: 'area',
    edit: 'Edit',
    export: 'Export',
    lost: 'Lost',
    noData: 'No tags currently at your selection.',
    noTime: 'No time recorded',
    search: 'Search',
    site: 'site',
    noHistory: 'No outdoor history found for date range',
    asOfDate: 'Data as of %{date}',
    refresh: 'Refresh',
    batteryState: {
      good: 'Good',
      bad: 'Low/Empty'
    }
  },
  fileupload: {
    drop: 'Drag & Drop or upload file (%{extensions})'
  },
  login: {
    account: 'Account',
    createAccount: 'Create an Account',
    email: 'Email',
    errorBody: "You've entered an invalid email address or password.",
    errorTitle: "Something doesn't look right.",
    forgotPassword: 'Forgot Password?',
    resetPassword: 'Reset Password',
    login: 'Login',
    password: 'Password',
    username: 'Username or Email',
    next: 'Next'
  },
  forgotPassword: {
    reset: 'Reset Password',
    txt: 'To reset your password, enter your email used to login',
    success: 'An email has been sent with instructions to reset your password',
    login: 'Back to login'
  },
  input: {
    showpassword: 'Show password',
    hidepassword: 'Hide password'
  },
  resetPassword: {
    confirmPassword: 'Confirm Password',
    txt: 'Please enter a new password to change',
    success: 'Your password has changed, please login',
    save: 'Save',
    login: 'Back to login',
    passwordRules: 'Password must be at least 8 characters',
    invalidToken: 'Email link has expired',
    forgotPasswordTxt: 'Click here to request a new one'
  },
  newuser: {
    txt: 'Welcome to Airfinder, please create a password to get started.',
    resendEmailTxt: 'Click here to resend the verification email',
    success: 'Your password has been saved, the process is complete.  Login below to enter Airfinder',
    resendEmailSuccess: 'Email has been sent, allow a moment before checking.',
    invalidParameters: 'Missing parameters, can not verify.  Please click on the link again from the email sent.'
  },
  models: {
    action: {
      alert: 'Show an alert',
      email: 'Send an email',
      emailAction: 'Send an email to %{customValue}.',
      emailValue: 'Email',
      sms: 'Send an SMS',
      smsAction: 'Send an SMS to %{customValue}.',
      smsValue: 'Phone Number',
      type: 'Action Type'
    },
    area: {
      areaLocation: 'Area Location',
      file: 'File',
      geoReferenced: 'Geo Referenced',
      indoor: 'Indoor',
      indoorOutdoor: 'Indoor/Outdoor',
      isGeoReferenced: 'Yes',
      isNonGeoReferenced: 'No',
      outdoor: 'Outdoor',
      locations: 'Locations',
      name: 'Area Name',
      site: 'Site',
      zones: 'Zones'
    },
    category: {
      name: 'Category'
    },
    criteria: {
      equals: 'The %{type} %{property} equals %{compareTo}.',
      in: 'The tag is in the %{property} %{compareTo}.',
      is: 'The %{type} %{property} is %{compareTo}.',
      isGreaterThan: 'The %{type} %{property} is greater than %{compareTo}.',
      isLessThan: 'The %{type} %{property} is less than %{compareTo}.',
      isNot: 'The %{type} %{property} is not %{compareTo}.',
      known: 'The %{type} %{property} is known.',
      lost: 'The tag is lost.',
      notEqual: 'The %{type} %{property} does not equal %{compareTo}.',
      notIn: 'The tag is not in the %{property} %{compareTo}.',
      notLost: 'The tag is not lost.',
      unknown: 'The %{type} %{property} is unknown.',
      type: {
        accessPoint: 'Access Point Property',
        listMembership: 'List Membership',
        tagProperty: 'Tag Property',
        referencePoint: 'Location Beacon Property'
      }
    },
    group: {
      name: 'Group Name'
    },
    location: {
      name: 'Location Name',
      address: 'MAC Address',
      locationId: 'Location ID',
      locationIdPlaceholder: '00 : 00 : 00 : 00 : 00 : 00',
      point: 'The Location',
      site: 'Site',
      area: 'Area',
      zone: 'Zone'
    },
    site: {
      areas: 'Areas',
      name: 'Site Name',
      labels: {
        tag: 'Tag',
        group: 'Group',
        category: 'Category',
        field1: 'Field1',
        field2: 'Field2',
      }
    },
    tag: {
      area: 'Area',
      battery: 'battery',
      batteryUnknown: 'unknown',
      batteryLevel: 'Battery Level',
      category: 'Category',
      cellId: 'Cell ID',
      field: 'Field',
      field1: 'Field 1',
      field2: 'Field 2',
      gps: 'GPS',
      group: 'Group',
      homeLocation: 'Set Home Location',
      humidity: 'Humidity',
      humidityLevel: 'Humidity Level',
      id: 'Mac Address',
      idPlaceholder: '00 : 00 : 00 : 00 : 00 : 00',
      lastSeen: 'Last seen',
      location: 'Location',
      lost: 'Lost',
      mac: 'Mac Address',
      name: 'Tag Name',
      shock: 'Shock',
      site: 'Site',
      tag: 'tag',
      tagAge: 'Track tag age',
      temperature: 'Temperature',
      time: 'Time',
      timeInService: 'Time In Service',
      wifi: 'Wifi',
      zone: 'Zone'
    },
    trigger: {
      automatically: 'Automatically',
      criteria: 'Trigger Criteria',
      manually: 'Manually',
      type: 'Trigger Workflows'
    },
    user: {
      name: 'User Name',
      email: 'Email',
      recaptcha: 'reCAPTCHA',
      sitePermissions: 'Site permissions',
      userPermissions: 'User permissions',
      editLabel: 'Edit Site Permission(s)',
      password: 'Password'
    },
    workflow: {
      activeTags: 'Active Tags',
      created: 'Created',
      createdBy: 'Created By',
      lastUpdated: 'Last Updated',
      name: 'Workflow Name',
      totalTags: 'Total Tags',
      type: 'Type',
      workflowName: 'Name'
    },
    zone: {
      area: 'Area',
      polygon: 'The Zone',
      site: 'Site',
      zone: 'Zone Name'
    }
  },
  userPermissions: {
    Admin: 'Admin',
    Status: 'Status',
    AddTags: 'Add Tags',
    EditDeleteTags: 'Edit/Delete Tags',
    ADDEDITDELETEGROUPSANDCATEGORIES: 'Add/Edit/Delete Groups & Categories'
  },
  error: {
    email: 'Enter a valid email',
    fileFormat:
      'The file needs to be one of the following formats %{extensions}',
    fileSize: 'The file exceeds the maximum file size of %{size}',
    fileUpload: 'There was a problem uploading your file',
    invalidDateRange: 'Please select a valid date range.',
    invalidPolygon:
      '%{fieldName} is not valid. It should not contain intersections with itself.',
    maxLength: '%{fieldName} exceeds the maximum length of %{length}.',
    minLength: '%{fieldName} minimum length is %{length}.',
    pattern: '%{fieldName} needs to be in the format %{pattern}.',
    pointNotInPolygon:
      '%{fieldName} should be contained by the %{parentFieldName}.',
    required: '%{fieldName} is required.',
    msg: 'Oops !! ',
    400: ' Something went wrong. Please try again.',
    403: ' You do not have permission to perform this action.',
    500: ' Internal server Error. Please try again.',
    errorheader: 'ERROR OCCURED'
  },
  referencePointTableHeader: {
    title: 'Location Beacons Health',
    zone: 'Zone',
    location: 'Location',
    rp: 'RP Mac',
    ap: 'Last AP Access (UTC)',
    apmac: 'Last Connected AP',
    status: 'Status',
    referenceTitle: 'Location Beacons',
    battery: 'Battery Status',
    hbTime: 'Last Heartbeat',
    hbStatus: 'Lost'
  },
  accessPointTableHeader: {
    title: 'Access Points Health',
    status: 'Status',
    nodeAddress: 'Node Address',
    gatewaynode: 'Host Gateway Node',
    rpcount: 'RP Count',
    tagcount: 'Tag Count',
    lastseenap: 'Last Msg Date (UTC)',
    accessTitle: 'Access Points'
  },
  gatewayTableHeader: {
    title: 'Gateways Health',
    status: 'Status',
    nodeAddress: 'Node Address',
    nodeName: 'Name',
    apcount: 'AP Count',
    downtime: 'Down Time(hr)'
  },
  confirmation: {
    message: 'Would you like to',
    confirm: 'Confirm',
    reject: 'Reject'
  }
};

export default translations;



// WEBPACK FOOTER //
// ./src/i18n/en.js